import React, {Component} from "react";
import AlbumView from "./AlbumLightbox";
import DeleteModal from "./DeleteModal";
import UploadMedia from "components/Spotlight/Album/UploadMedia";
import AxiosConfig from "../../../axiosConfig";
import {getUserMedia} from "./GetImages";

const ipPrefix = String(process.env.REACT_APP_API_ENDPOINT).slice(0,process.env.REACT_APP_API_ENDPOINT.length-1);

class UserAlbum extends Component {

    constructor() {
        super();

        this.state = {
            content: getUserMedia(),
            currIndex: null,
            isOpen: false,
            status: null,
            selectedMedia:null,
            show: false,
            newUpload: false,
        };
        this.mediaRef = React.createRef();
        this.toggleModal = this.toggleModal.bind(this);
        this.selected = this.selected.bind(this);
        this.nextMedia = this.nextMedia.bind(this);
        this.prevMedia = this.prevMedia.bind(this);
        this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);
        this.refresh = this.refresh.bind(this);
        this.displayContent = this.displayContent.bind(this);
        this.setUploaded = this.setUploaded.bind(this);
        this.displayVid = this.displayVid.bind(this);
    }
    componentDidMount() {
        if (this.state.total === 0) {
        }
        this.refresh();
    }

    setUploaded()
    {
        if (this.state.newUpload === false){
            this.setState({newUpload:true});
            this.refresh();
        }
    }

    refresh = () => {
        if (this.state.newUpload === true) {
            let fileInfo = {
                typ: "",
                addr: ""
            };
            let retArr = [{}];
            AxiosConfig
                .get("mediaManager/get_album/",)
                .then((response) => {
                    for (let i = 0; i < response.data.length; i++) {
                        fileInfo = {type: response.data[i].media_type, addr: ipPrefix + response.data[i].media}
                        retArr[i] = fileInfo;
                    }
                    this.setState({
                        content: retArr,
                        newUpload: false,
                    })
                });
        }
    }

    toggleModal= () => {
        if (this.state.isOpen) {
            this.selected(-1);
        }
        this.setState({isOpen: !this.state.isOpen});
    }

    toggleDeleteModal= () => {
        this.setState({show: !this.state.show});
        this.refresh();
    }

    selected= (path) => {
        if (path === -1) {
            if (this.state.content[this.state.currIndex].type === 'V'){
                this.setState({
                    selectedMedia:
                        <video key={-1} className="album-focus-media--vid" width="750" height="500" muted>
                            <source src={null} type="video/mp4"/>
                        </video>
                });
            }
        }
        else {
            if (this.state.content === [] || this.state.content === [{}]) {
            } else {
                let addr = this.state.content[path];
                this.setState({currIndex: path});
                if (addr.type === "I") {
                    this.setState({
                        selectedMedia:
                            <img className="album-focus-media--img" src={addr.addr}/>
                    });
                } else if (addr.type === "V") {
                    this.setState({
                        selectedMedia:
                            <video key={addr.addr} className="album-focus-media--vid" width="750" height="500" autoPlay
                                   controls={true}>
                                <source src={addr.addr} type="video/mp4"/>
                            </video>
                    });
                }

                if (this.state.isOpen === false) {
                    this.toggleModal();
                }
            }
        }
    }

    nextMedia(){
        let newIdx = (this.state.currIndex === this.state.content.length - 1 ? 0 : this.state.currIndex + 1);
        this.setState({
            currIndex: (newIdx)
        });
        this.selected(newIdx);
        this.refresh();
    }

    prevMedia(){
        let newIdx = (this.state.currIndex === 0 ? this.state.content.length - 1 : this.state.currIndex -1);
        this.setState({
            currIndex: (newIdx)
        });
        this.selected(newIdx);
        this.refresh();
    }

    displayVid = (item, inde) => {
        let vSrc = item.addr;
        return (
            <video className="user-media" key={inde}  width="750" height="500" onClick={() => (
                this.selected(inde)
            )}>
                <source src={vSrc} type="video/mp4"/>
            </video>
        );
    }

    displayContent = () => {
        let med = this.state.content;
        return (
            med.map((addr, i) => (
                addr.type === "I" ? (
                    <img className="user-media" key={i} src={addr.addr} alt={"Error Loading"} onClick={() => (
                        this.selected(i)
                    )}
                    />
                ) : (
                    this.displayVid(addr, i)
        ))));
    }

    deleteMedia() {
        let orig = this.state.content;
        let num = this.state.currIndex;
        let userImage = this.state.content[num].addr
        let imgId = 0
        const ipPrefix = String(process.env.REACT_APP_API_ENDPOINT).slice(0,process.env.REACT_APP_API_ENDPOINT.length-1);
        let retArr = [];
        let idArr = [];
        AxiosConfig
            .get("mediaManager/media/",)
            .then((response) =>
            {
                for (let i = 0; i < response.data.length; i++) {
                    retArr[i] = ipPrefix + response.data[i].media;
                    idArr[i] = response.data[i].id;
                }
                imgId = idArr[retArr.indexOf(userImage)]
                AxiosConfig.delete(`${ipPrefix}/mediaManager/media_delete_details/${imgId}/`).then(() =>
                    this.setState({ status: 'Delete successful' }));
            });
        orig.splice(num,1);
        if (orig === undefined) {
            this.setState({
                currIndex:null,
            });
            this.toggleModal();
        }
        else {
            this.prevMedia();
            this.setState({content:orig});
        }
        this.refresh();
    }

    render() {
        const isOpen = this.state;
        return (
            <section className={"d-flex"} style={{"flexDirection":"column"}}>
                <UploadMedia refresh = {this.refresh} uploadToggle = {this.setUploaded}/>
                <div id="user-gallery">
                    {this.displayContent()}
                </div>
                <div>
                    {isOpen && (
                        <AlbumView
                            stat = {this.state}
                            show={this.state.isOpen}
                            handleClose={this.toggleModal}
                            requestNext= {this.nextMedia}
                            requestPrev= {this.prevMedia}
                            requestDelete = {this.toggleDeleteModal}
                        />)}
                </div>
                <div>
                    <DeleteModal show={this.state.show} handleClose={this.toggleDeleteModal} handleDelete={this.deleteMedia}>
                        <p>Are you sure you want to delete this file?</p>
                    </DeleteModal>
                </div>
            </section>
        );
    }
}

export default UserAlbum;
